module.exports = __webpack_public_path__ + "img/my_profile.e9980ac1.png";